import React from 'react';
import { Link } from 'react-router-dom';
import './QRScanner.css';

const QRScanner: React.FC = () => {
  return (
    <div className="qr-scanner-container">
      <div className="qr-scanner-content">
        <h1>⚠️ GOTTCHA ⚠️ </h1>
        <h2>QR Code Scanner Warning</h2>
        <div className="app-recommendation">
          <h2>APP DOWNLOAD HOOK HERE</h2>
        </div>

        <div className="warning-section">
          <h2>Important Security Notice</h2>
          <p>
            Scanning random QR codes can pose serious security risks to your personal information and devices.
            Malicious QR codes can:
          </p>
          <ul>
            <li>Redirect you to phishing websites</li>
            <li>Download malware to your device</li>
            <li>Expose your personal data to cybercriminals</li>
            <li>Compromise your financial information</li>
          </ul>
        </div>

        <div className="safe-practice-section">
          <h2>Safe QR Code Scanning Practices</h2>
          <p>Always follow these security guidelines:</p>
          <ul>
            <li>Only scan QR codes from trusted sources</li>
            <li>Verify the destination URL before proceeding</li>
            <li>Use *insert app name here* for scanning sensitive information</li>
            <li>Keep your device's security software up to date</li>
          </ul>
        </div>



        <div className="back-home">
          <Link to="/" className="home-link">Return to Home</Link>
        </div>
      </div>
    </div>
  );
};

export default QRScanner; 